export function summarizeUserQuestionAnswer(fields, declined) {
  if (declined) return { status: "已拒绝回答", items: [] }

  const items = fields.map(field => {
    const values = Array.isArray(field.values) ? field.values.filter(value => value) : []
    return {
      label: field.label,
      value: values.join("、")
    }
  }).filter(item => item.label && item.value)

  return { status: "回答已提交", items }
}
